import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.less';
import '@/declare/styles/index.less';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN'
import { useEffect, useState } from 'react';
import localStore, { USER_NAME, USER_UUID } from './store/local-store';
import React from 'react';
import { createContext } from 'react';
import { EngineStatus, useEngineService } from './store/engine-store';
import 'bimui/dist/bimui.css';
import Login from './layout/login/login';
import Layout from './layout/screen';
import './components/menu-fc/index.less';
import '@/declare/styles/table.less';
import { SystemStatus, useSystemService } from './store/system-store';

export const EngineContext = createContext<EngineStatus>(null);
export const SystemContext = createContext<SystemStatus>(null);


function App() {
    const navigate = useNavigate();
    const location = useLocation(); // 获取当前路由的路径
    const engineContext = useEngineService();
    const systemContext = useSystemService();

    let timer$;

    /**
     * 定期校验登录
     */
    useEffect(() => {
        // checkLogin();
        // timer$ = setInterval(() => {
        //     checkLogin();
        // }, 60000)
        // return (() => {
        //     clearInterval(timer$);
        // })
    }, [])


    /**
     * 校验登录
     * @returns 
     */
    // const checkLogin = () => {
    //     let token = localStore.token || '';
    //     if (token.length <= 0) {
    //         if (!location.pathname.includes('login')) {
    //             localStore.clear();
    //             navigate('/login')
    //         }
    //         return;
    //     }
    //     userCheckLogin()
    //         .then(res => {
    //             let userDetail: User = res.data;
    //             localStore.set(USER_UUID, userDetail.uuid);
    //             localStore.set(USER_NAME, userDetail.name);
    //             navigationContext.setIsDemoUser(userDetail.type === 3);
    //         }).catch(err => {
    //             localStore.clear();
    //             navigate('/login')
    //         })
    // }

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
                components: {
                    Radio: {
                        dotSize: 10,
                        radioSize: 14,
                        buttonPaddingInline: 8,
                        wrapperMarginInlineEnd: 4,
                    },
                },
            }}
        >
            <SystemContext.Provider value={systemContext}>
                <EngineContext.Provider value={engineContext}>
                    <div className="tn-base">
                        <Routes>
                            {/* <Route path='/login/*' element={<Login />} /> */}
                            <Route path='/screen' element={<Layout />} />
                            {/* <Route path='/screen/monix-projects/:monixProjectId/projects/:projectUuid/mObjects/:mObjectId/*' element={<Layout />} />
                            <Route path='/screen/monix-projects/:monixProjectId/projects/:projectUuid/*' element={<Layout />} /> */}
                            <Route path='/screen/*' element={<Layout />} />
                            <Route path="*" element={<Navigate to="/screen/monix/67/bim/0a366432-d40b-4477-9ece-f56a9ea04152/models/3a990dbf-66db-423a-bec7-0f7ad97754ac" />} />
                        </Routes>
                    </div>
                </EngineContext.Provider>
            </SystemContext.Provider>
        </ConfigProvider>
    );
}

export default App;
